import type {ParameterDefinitionType} from '@volkswagen-onehub/vw-starter-framework';

import type {CommonQueryParamsV2} from '@volkswagen-onehub/vw-starter-bff-support';

/**
 * Common parameter interface
 */
export type CommonBffParameter = CommonQueryParamsV2;

/**
 * Common parameter definitions for all bff endpoints.
 */
export const commonParameterDefinition: ParameterDefinitionType<CommonBffParameter> =
  {
    cacheBustingAllowed: {
      cacheKey: true,
      type: 'boolean',
      description:
        'Toggle to cache busting of service config endpoint service.',
    },
    countryCode: {
      required: true,
      cacheKey: true,
      description: 'Country code for Internationalization',
    },
    debug: {
      required: false,
      cacheKey: true,
      description:
        'A parameter that can be used to bust bff cache or display i18n keys for debugging and development purposes ',
    },
    endpoint: {
      required: true,
      cacheKey: true,
      description:
        'Identifies the feature apps environment and will be passed to the service config endpoint service.',
    },
    language: {
      required: true,
      cacheKey: true,
      description: 'Language code for Internationalization',
    },
    mockIds: {
      required: false,
      cacheKey: true,
      multiple: true,
      description:
        'Identifies the feature apps environment and will be passed to the service config endpoint service.',
    },
    mocksServerName: {
      cacheKey: true,
      type: 'string',
      description:
        'Identifies the feature apps environment and will be passed to the service config endpoint service.',
    },
    oneapiKey: {
      cacheKey: true,
      type: 'string',
      description: 'Api key to be passed to neapi services.',
    },
    dataVersion: {
      cacheKey: true,
      type: 'string',
      description:
        'Data version is a key from the data version service to bust caches of CMS http services.',
    },
  };
